import { render, staticRenderFns } from "./HubMetaForm.vue?vue&type=template&id=6963cb4c&"
import script from "./HubMetaForm.vue?vue&type=script&lang=js&"
export * from "./HubMetaForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports